<template>
  <div class="nav-header">
    <b-navbar toggleable="sm" type="light">
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item href="/home">
            <router-link to="/home">首页</router-link>
          </b-nav-item>
          <b-nav-item href="/about">
            <router-link to="/about">平台概况</router-link>
          </b-nav-item>
          <b-nav-item href="/department">
            <router-link to="/department">研究部门</router-link>
          </b-nav-item>
          <b-nav-item href="/people">
            <router-link to="/people">人才队伍</router-link>
          </b-nav-item>
          <b-nav-item href="/facility">
            <router-link to="/facility">仪器平台</router-link>
          </b-nav-item>
          <b-nav-item href="/research">
            <router-link to="/research">科学研究</router-link>
          </b-nav-item>
          <!-- <b-nav-item>
            <router-link to="/news">新闻通知</router-link>
          </b-nav-item> -->
          <b-nav-item href="/collaboration">
            <router-link to="/collaboration">交流合作</router-link>
          </b-nav-item>
          <b-nav-item href="/join-us">
            <router-link to="/join-us">加入我们</router-link>
          </b-nav-item>
          <b-nav-item href="/contact-us">
            <router-link to="/contact-us">联系我们</router-link>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.nav-header {
  min-width: 1300px;
  padding: 0;
  margin: 0;
  height: 60px;
  background-color: #f0f0f0;
  opacity: 0.9;
  nav {
    padding: 0 10px;
    margin-top: 0;
  }
}
.navbar {
  margin: auto;
  padding-right: 10px;
  padding-left: 10px;
  width: 1300px;
  .nav-item {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 18px;
    padding-right: 18px;
    height: 60px;
  }
  .nav-link {
    padding-top: 0;
    padding-bottom: 0;
    height: 60px;
    text-align: center;
  }
  a {
    font-size: 19px;
    text-decoration: none;
    margin: 0 4px;
    padding-top: 5px;
    line-height: 50px;
    padding-bottom: 0px;
    display: inline-block;
    color: #000;
    font-weight: bold !important;
    :hover {
      color: #931b22 !important;
    }
    .active {
      color: #931b22 !important;

      border-bottom: 4px solid #931b22;
    }
  }
}
</style>
